export const SUBTITLE_PRESET_KARAOKE = "karaoke";
export const SUBTITLE_PRESET_HIGHLIGHT = "highlight";
export const SUBTITLE_PRESET_BOXED = "boxed";

export const PRESET_HIGHLIGHT_MODE = {
  [SUBTITLE_PRESET_KARAOKE]: "karaoke",
  [SUBTITLE_PRESET_HIGHLIGHT]: "word",
  [SUBTITLE_PRESET_BOXED]: "underline",
};

export const BOXED_PRESET_COLORS = {
  subtitleColor: "#000000",
  backgroundColor: "#D4FF00",
};

export const getPresetVisualDefaults = (preset) => {
  switch (preset) {
    case SUBTITLE_PRESET_BOXED:
      return {
        doHighlight: true,
        hasBackground: true,
        fontStyle: "bold",
        subtitleColor: BOXED_PRESET_COLORS.subtitleColor,
        backgroundColor: BOXED_PRESET_COLORS.backgroundColor,
        highlightMode: "underline",
      };
    case SUBTITLE_PRESET_KARAOKE:
      return {
        doHighlight: true,
        hasBackground: false,
        subtitleColor: "#FFFFFF",
        highlightColor: "#00FFBF",
        highlightMode: "karaoke",
      };
    case SUBTITLE_PRESET_HIGHLIGHT:
      return {
        doHighlight: true,
        hasBackground: false,
        subtitleColor: "#FFFFFF",
        highlightColor: "#00FFBF",
        highlightMode: "word",
      };
    default: {
      return getPresetVisualDefaults(SUBTITLE_PRESET_BOXED);
    }
  }
};

export const DEFAULT_SUBTITLE_OPTIONS = {
  preset: SUBTITLE_PRESET_BOXED,
  fontFamily: "Open Sans",
  highlightColor: "#00FFBF",
  ...getPresetVisualDefaults(SUBTITLE_PRESET_BOXED),
};

export const resolveSubtitlePreset = (options = {}) => {
  switch (options.preset) {
    case SUBTITLE_PRESET_KARAOKE:
    case SUBTITLE_PRESET_HIGHLIGHT:
    case SUBTITLE_PRESET_BOXED:
      return options.preset;
    default:
      break;
  }
  switch (options.highlightMode) {
    case "karaoke":
      return SUBTITLE_PRESET_KARAOKE;
    case "word":
      return SUBTITLE_PRESET_HIGHLIGHT;
    case "underline":
      return SUBTITLE_PRESET_BOXED;
    default:
      return SUBTITLE_PRESET_BOXED;
  }
};

export const buildSubtitleOptionsPayload = (data) => {
  const preset = resolveSubtitlePreset(data);
  const highlightMode = PRESET_HIGHLIGHT_MODE[preset];
  return {
    ...data,
    preset,
    highlightMode,
    doHighlight: preset === SUBTITLE_PRESET_BOXED ? true : !!data.doHighlight,
    hasBackground: preset === SUBTITLE_PRESET_BOXED,
  };
};
